import { Pipe, PipeTransform } from '@angular/core';
import moment_ from 'moment';
const moment = moment_;

@Pipe({
    name: 'tzName'
})
export class TimezoneNamePipe implements PipeTransform {
    /** @params tz: takes in a timezone e.g. 'America/Timezone' and shows the abbreviation and offset */
    transform(tz: string): any {
        const t = moment().tz(tz);
        let text = '';
        if ((tz || '').indexOf('/') > -1) {
            text += tz.split('/')[1];
        }
        if (t) {
            if (t.format('z') >= 'A') {
                text += ' - ' + t.format('z');
            }

            text += ' [GMT' + t.format('Z') + ']';
        }

        return text;
    }
}
